import { Box, } from "@mui/material";
import logo from "./../assets/images/logo.jpg";
import new_logo from "./../assets/images/new_logo.png";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";

 const Header = ({type}) => {
    const navigate = useNavigate();
    
    return <Fragment>
        <Box
            sx={{
                display: "flex",
                boxShadow: 1,
                position: "fixed",
                backgroundColor: "#fff",
                width: "100%",
                zIndex: 999,
                padding:'12px'
            }}
            className=""
        >
            {window.history.state.idx !== 0 && (
                <IconButton
                    onClick={() => navigate(-1)}
                >
                    <ArrowBackIcon />
                </IconButton>
            )}
            <img
                src={new_logo}
                alt=""
                className="ml-11 max-w-full h-auto"
            />
            { type === 'pp' && (<div className="ml-11 flex items-center"><span className="text-xl text-[#2B549A] font-semibold hidden sm:block">Point Delivery Service</span></div>) }
           
        </Box>
    </Fragment>
}

export default Header;